'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useResizeObserverRef", {
    enumerable: true,
    get: function() {
        return useResizeObserverRef;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const useResizeObserverRef = (callback)=>{
    const { targetDocument } = (0, _reactsharedcontexts.useFluent_unstable)();
    const [observer] = _react.useState(()=>{
        var _targetDocument_defaultView;
        const ResizeObserverConstructor = targetDocument === null || targetDocument === void 0 ? void 0 : (_targetDocument_defaultView = targetDocument.defaultView) === null || _targetDocument_defaultView === void 0 ? void 0 : _targetDocument_defaultView.ResizeObserver;
        if (ResizeObserverConstructor) {
            return new ResizeObserverConstructor(callback);
        }
    });
    const ref = _react.useCallback((element)=>{
        if (element) {
            observer === null || observer === void 0 ? void 0 : observer.observe(element);
        } else {
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
        }
    }, [
        observer
    ]);
    return ref;
};
